import { render } from "./MoveDevice.vue?vue&type=template&id=176aba56"
import script from "./MoveDevice.vue?vue&type=script&lang=js"
export * from "./MoveDevice.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__